export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/paypal.d82fd40c.svg","height":24,"width":38};